export const logsPaths = {
  absolute: '/:clientId/logs',

  logMessage: {
    absolute: '/:clientId/logs/:logId/argument/:argumentKey/message',
    relative: ':logId/argument/:argumentKey/message',
  },
} as const;
